// A Decision Room can hold two kinds of video: produced trailers and
// full call recordings. Both the seller's room page and the prospect's
// room use these to group and label them so nobody mistakes a raw
// 40-minute call for a highlight reel (or the reverse).

const FULL_RECORDING_KINDS = ['meeting', 'qualifying_call'];

export function isFullRecording(r) {
  return !!r && FULL_RECORDING_KINDS.includes(r.recordingKind);
}

export function splitRecordings(list) {
  const trailers = [];
  const fullRecordings = [];
  for (const r of list || []) (isFullRecording(r) ? fullRecordings : trailers).push(r);
  return { trailers, fullRecordings };
}

export function fmtRecordingLength(seconds) {
  if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds <= 0) return null;
  const total = Math.round(seconds);
  if (total >= 3600) return `${Math.floor(total / 3600)}h ${Math.floor((total % 3600) / 60)}m`;
  if (total >= 60) return `${Math.round(total / 60)} min`;
  return `${total}s`;
}

export function kindLabel(r) {
  return isFullRecording(r) ? 'Full recording' : 'Trailer';
}

// Short line under the label: what the viewer is about to watch.
export function kindBlurb(r) {
  const len = fmtRecordingLength(r && r.durationSeconds);
  if (isFullRecording(r)) {
    return len ? `The complete call, unedited · ${len}` : 'The complete call, unedited';
  }
  return 'A short cut of the highlights';
}

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

export function countsSummary(list) {
  const { trailers, fullRecordings } = splitRecordings(list);
  const parts = [];
  if (trailers.length) parts.push(plural(trailers.length, 'trailer'));
  if (fullRecordings.length) parts.push(plural(fullRecordings.length, 'full recording'));
  return parts.join(' · ');
}
